import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";
import { download, edit, search, view } from "../../assets/img";
import Topbar from "../../Component/Topbar/Topbar";
import { Table } from "../../Component/Table/Table";
import { Modal } from "react-bootstrap";
import { BASE_URL, URLS } from "../redux/api/Constants";
import toast from "react-hot-toast";
import { post } from "../redux/api/ApiHandler";
import useSearchFunction from "../../Component/searchFunction";

const Customer = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [popup, setPopup] = useState(false);
  const [errPopup, setErrPopup] = useState(false);
  const [errList, setErrList] = useState("");
  const [fileUpload, setFileUpload] = useState({});
  const [searchValue, setSearchValue] = useState("");

  const debounceval = useSearchFunction(searchValue);

  const handleClose = () => {
    setPopup(false);
  };
  const handleErrClose = () => {
    setFileUpload({ name: "" });
    setErrList("");
    setErrPopup(false);
  };

  const sampleExcelDownload = () => {
    try {
      const link = document.createElement("a");
      link.href = BASE_URL + URLS.SAMPLE_DATE_EXCEL_DOWNLOAD;
      link.setAttribute("download", "");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log("error", error);
    }
  };

  const customerImport = () => {
    if (fileUpload?.name) {
      let formdata = new FormData();
      formdata.append("file", fileUpload);
      post(URLS.IMPORT_CUSTOMER, formdata)
        .then((res) => {
          if (res?.status == "success") {
            // getDateList();
            customerList();
            setFileUpload("");
            handleClose();
            toast.success(res?.message);
          } else {
            handleClose();
            setErrPopup(true);
            setErrList(res?.failed_rows);
            // toast.error(res?.message);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Upload a File");
    }
  };

  const customerList = async (search) => {
    setSearchValue(search);
    let payload = {
      search: search,
      page: page,
    };
    let res = await post(URLS.CUSTOMERS_LIST, payload);
    if (res?.status == "success") {
      console.log("calling");
      let mapData = res?.lists?.map((i) => {
        return {
          ...i,
          page: res?.pagination_meta?.current_page,
        };
      });
      console.log(mapData, "mapData");
      setList(mapData);
      setPagination(res?.pagination_meta);
    }
  };

  useEffect(() => {
    customerList(debounceval);
  }, [debounceval, page]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "page",
        Cell: ({ value, row }) => {
          return <p>{(value - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Customer ID ",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Address",
        accessor: "address",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Mobile Number",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Email ID",
        accessor: "email",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Region",
        accessor: "region",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer/Dealer",
        accessor: "type",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },

      {
        Header: "Location",
        accessor: "location",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Quantity",
        accessor: "quantity",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      // {
      //   Header: "Date",
      //   accessor: "date",
      //   Cell: ({ value, row }) => {
      //     return <p className="text-nowrap ">{value ? moment(value).format("DD-MM-YYYY") : ""}</p>;
      //   },
      // },
      {
        Header: "Printers",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <button
              onClick={() => {
                navigate("/customer-printers", {
                  state: {
                    data: row?.original,
                    type: "view",
                    id: row?.original?.id,
                  },
                });
              }}
              className="cust-btn ms-2"
            >
              <img src={view} alt="" className=" editor-btn " />
            </button>
          );
        },
      },
    ],
    [],
  );
  return (
    <>
      <Topbar header={"Customer"} />
      <div className="container_fluit1">
        <div className="d-flex ac-jb">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total Customers : {pagination?.total}
          </h4>

          <div
            onClick={() => setPopup(true)}
            className="d-flex ac-jc import gap-2 pointer"
          >
            <img src={download} height={18} />
            <p className="f3 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-18">
              Import
            </p>
          </div>
        </div>
        <div className="d-flex ac-je gap-4">
          {/* <div className="col-md-2">
            <SelectBox selected={selected} setSelected={setSelected} />
          </div> */}

          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              type="text"
              placeholder="Search "
              style={{ border: "none", width: "200px" }}
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list ?? []}
          show={true}
        />
      </div>
      {popup && (
        <Modal show={popup} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title> Import Excel</Modal.Title>
          </Modal.Header>
          <div className="p-3">
            <button
              className="text-start cust-btn rounded-3 bg-primar p-2 d-grid  text-white"
              onClick={() => sampleExcelDownload()}
            >
              Sample Download
            </button>
            <div className="mt-4">
              <h6>Upload Excel</h6>
              <input
                type="file"
                className="form-control w-100 mt-3"
                accept=".xlsx, .xls, .csv"
                onChange={(e) => {
                  setFileUpload(e.target.files[0]);
                }}
              />
            </div>
          </div>
          <div className="d-flex justify-content-end pt-2 mb-3 mx-5">
            <button
              className="cust-btn bg-primar text-white rounded-3 p-2 d-grid m-3"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="cust-btn bg-primar text-white rounded-3 p-2 d-grid m-3"
              onClick={() => customerImport()}
            >
              Submit
            </button>
          </div>
        </Modal>
      )}
      {errPopup && (
        <Modal show={errPopup} onHide={handleErrClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Import Failed</Modal.Title>
          </Modal.Header>
          <div className="p-3 table-design">
            <table className="table-border custom-table-design">
              <thead>
                <th className="no-wrap white">S.No</th>
                <th className="no-wrap white">Row</th>
                <th className="no-wrap white">Errors</th>
              </thead>
              <tbody>
                {errList?.map((item, ind) => {
                  return (
                    <tr>
                      <td>{ind + 1}</td>
                      <td>{item?.row_index}</td>
                      <td>
                        {item?.errors?.map((err, eind) => {
                          return (
                            <ul key={eind}>
                              <li>{err}</li>
                            </ul>
                          );
                        })}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-end pt-2 mb-3 mx-5">
            <button
              className="cust-btn bg-primar text-white rounded-3 p-2 d-grid m-3"
              onClick={handleErrClose}
            >
              Close
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Customer;
